module.exports = __webpack_public_path__ + "static/media/criandoMarcasGuiaVisualConceitoDesign.a73a0269.png";